export const DEFAULT_WIZARD_FORM_VALUES = {
  romo: {
    english: {
      intro: {
        title: "Important Job Applicant &\nNew Employee Questionnaire",
      },
    },
    spanish: {},
  },
  allText: {
    english: {
      shared: {
        language_name: "English",
        subtitle:
          "Honest answers are always best! Please answer each question.",
        yes: "Yes",
        date_selection: "Please, select Month, Year, then Day",
        no: "No",
        true: "True",
        false: "False",
        back: "Back",
        previous: "Previous",
        next: "Next",
        required: "Required",
        invalid_ss_number: "Invalid social security number",
        invalid_tel_number: "Invalid phone number",
        invalid_email: "Invalid email address",
        invalid_state: "Invalid state",
        invalid_zip_: "Invalid zip code",
        change_language: "Change Language",
        first_name: "First Name",
        last_name: "Last Name",
        month: "Mon",
        day: "Day",
        year: "Year",
        months: {
          jan: "JAN",
          feb: "FEB",
          mar: "MAR",
          apr: "APR",
          may: "MAY",
          jun: "JUN",
          jul: "JUL",
          aug: "AUG",
          sep: "SEP",
          oct: "OCT",
          nov: "NOV",
          dec: "DEC",
        },
        state: "State",
        federal: "Federal",
        states: [
          "AL",
          "AK",
          "AZ",
          "AR",
          "CA",
          "CO",
          "CT",
          "DE",
          "FL",
          "GA",
          "HI",
          "ID",
          "IL",
          "IN",
          "IA",
          "KS",
          "KY",
          "LA",
          "ME",
          "MD",
          "MA",
          "MI",
          "MN",
          "MS",
          "MO",
          "MT",
          "NE",
          "NV",
          "NH",
          "NJ",
          "NM",
          "NY",
          "NC",
          "ND",
          "OH",
          "OK",
          "OR",
          "PA",
          "RI",
          "SC",
          "SD",
          "TN",
          "TX",
          "UT",
          "VT",
          "VA",
          "WA",
          "WV",
          "WI",
          "WY",
          "AS",
          "DC",
          "FM",
          "GU",
          "MH",
          "MP",
          "PW",
          "PR",
          "VI",
          "AE",
          "AA",
          "AP",
        ],
        finish: "Finish",
        edit: "Edit",
        sign: "Sign",
        of: "of",
        answered: "answered",
        signed: "signed",
        startOver: "Start Over",
        date: "Date",
        email: "Email Address",
        continue: "Continue",
        required_message:
          "All questions must be completed. Please complete all fields before continuing.",
      },
      intro: {
        title: "Please Complete this Important Tax-Credit Questionnaire.",
        title2: "Ready to Complete the WOTC Questionnaire?",
        paragraph01:
          "WOTC Planet is requesting information to help this employer participate in the Work Opportunity Tax Credit (WOTC) Program, and the employer does not receive your responses. The WOTC Program is intended to help members of its targeted groups obtain employment by reducing employers' federal income tax.",
        paragraph02:
          "Providing responses to WOTC eligibility questions is voluntary. You will be treated the same whether you answer those questions or not. Information you provide will be kept confidential and may be disclosed to the state’s workforce agency to confirm eligibility. It will be used only for this purpose and in a manner consistent with the ADA and other nondiscrimination laws.",
        information02: "opt out",
        rightBottomInformation01: "We need your help!",
        rightBottomInformation02: "We can’t do it without you!",
        rightBottomInformation03: "Click CONTINUE now.",
      },
      intro01: {
        middleParagraph0101: "Just to confirm, ",
        middleParagraph0102:
          ", are you choosing to skip the WOTC eligibility questions?",
        middleParagraph0103:
          "Your answers are confidential and will not negatively affect your employment opportunity. It only takes a few minutes and supports a program helping employers invest in work opportunities in communities like yours.",
        middleParagraph02: "If you want to end now, click ",
        endNow: "End Now",
        middleParagraph03:
          "If you’ve changed your mind and would like to continue, click Continue below.",
        bottomParagraph01: "Your employer can lose a tax benefit without it.",
        bottomParagraph02: "To complete your WOTC form please click CONTINUE!",
      },
      info01: {
        title: "Employee Information",
        subtitle: "",
        name: "Name",
        ssn: "Social Security Number",
        ageRange: "Are you under the age of 40?",
        birthDate: "Date of Birth",
        birthDatePrompt: "If you are under age 40, enter your date of birth.",
        email: "Email Address",
        phone: "Phone Number",
        job_description: "Job Title or Description",
        starting_pay: "Starting pay (if known)",
        starting_pay_holder: "If unsure, an estimate is fine",
      },
      info02: {
        title: "Personal Information",
        subtitle: "(continued)",
        street: "Street Address (where you live)",
        city: "City",
        county: "County Name",
        state: "State",
        zip: "Zip Code",
        hireDate: "Hire Date (if known)",
        workedForUsBefore: "Have you worked for us before?",
        dobCheck: "Please double-check your date of birth",
      },
      section01: {
        title: "01",
        primaryQuestion: "Are you a veteran of the U.S. Military?",
        question01:
          "Are you entitled to compensation for a\nservice-related injury?",
        question02:
          "What was the date of your discharge or\nrelease from military service?",
        question03: "What branch of service?",
        question03Placeholder: "Branch",
      },
      section02: {
        title: "02",
        primaryQuestion:
          "Were you unemployed for any\ncombination of days adding up to 4\nweeks during the last year?",
      },
      section03: {
        title: "03",
        primaryQuestion:
          "Were you unemployed for any\ncombination of days adding up to 6\nmonths during the last year?",
      },
      section04: {
        title: "04",
        primaryQuestion:
          "Were you referred for this job by any of the following?\nPlease mark yes or no.",
        question01: "A vocational rehabilitation agency?",
        question02: "The Ticket to Work Program?",
        question03: "The Department of Veterans Affairs?",
      },
      section05: {
        title: "05",
        primaryQuestion:
          "Did you personally receive SSI -\nSupplemental Security Income at any\ntime in the past 3 months?",
      },
      section06: {
        title: "06",
        primaryQuestion: "Were you ever convicted of a felony?",
        question01: "Date of Conviction:",
        question02: "Date Released from Incarceration",
      },
      section06b: {
        title: "6b",
        primaryQuestion: "Please answer the following:",
        question04: "Was it a state or federal conviction?",
        question05: "City or County where convicted:",
        question05Placeholder: "City or County",
        question06: "State:",
        question06Placeholder: "State",
      },
      section06c: {
        title: "6c",
        primaryQuestion: "Please answer the following:",
        question07: "Parole or probation officer's name:",
        question07Placeholder: "Officer's Name",
        question08: "Parole or probation officer's phone number:",
        question08Placeholder: "Officer's phone number",
        question09: "Are you in a Work Release program?",
        question10:
          "Do you give WOTC Planet\npermission to contact you for more\ninformation about your Work Release\nprogram or conviction & release dates? By checking YES below, I give my permission.\n",
      },
      section07: {
        title: "07",
        primaryQuestion:
          "Did you or a family member in your home\nreceive SNAP (Supplemental Nutrition\nAssistance Program) or Food Stamps at\nany time during the last 6 months?",
      },
      section08: {
        title: "08",
        primaryQuestion:
          "Did you or a family member in your home\nreceive TANF (Temporary Assistance to\nNeedy Families) or welfare benefits at any\ntime in the last 3 ½ years?",
      },
      section09: {
        title: "09",
        primaryQuestion:
          "Did you or a family member in your home\nreceive SNAP (Supplemental Nutrition\nAssistance Program) or Food Stamps at any\ntime during the last 1 ½ years?",
      },
      section09b: {
        title: "9b",
        primaryQuestion:
          "Because someone in your home has received SNAP, Food Stamps, welfare, or TANF benefits, please provide the following:",
        summaryQuestion:
          "If your answer to any of the questions inside this box is yes, please provide the following:",
        question01:
          "Name of person who signed up to\nreceive the SNAP, Food Stamps,\nwelfare, or TANF benefits:",
        question01Placeholder: "Name",
        question02: "City and State where benefits were\nreceived:",
        question02Placeholder: "City and State",
      },
      section10: {
        title: "10",
        primaryQuestion:
          "Please answer the following statements as True or False:",
        question01:
          "Until I was hired here, I was unemployed\nfor 27 consecutive weeks (a little more\nthan 6 months) or longer.",
        question02:
          "During this period of unemployment,\nI received unemployment compensation\nat least one time.",
        unemploymentStart: "My period of unemployment started on:",
        unemployment_state:
          "State(s) where I received unemployment compensation:",
      },
      summary: {
        title:
          "Below is a summary of your answers. After verifying your answers, click the SIGN button at the bottom. If you need to go back and change your answers, click the EDIT button.",
        employeeInformation: "Employee Information",
        signatureTitle: "Sign Form",
        signatureStatementLabel: "Signature Statement",
        signatureStatement:
          "I declare under penalty of perjury that my responses are true to the best of my knowledge and belief. I understand WOTC Planet processes this information on behalf of my employer and my employer does not receive my responses. \n" +
          "\n" +
          "To verify eligibility: I authorize WOTC Planet to verify my dates of military service and other information provided and to contact me if necessary. WOTC Planet may transfer my information onto forms required by the state workforce agency. Electronic and Faxed forms and signatures may be used as originals. These authorizations expire in 24 months, but I may cancel them sooner by contacting WOTC Planet.",
        signatureLabel: "Sign and declare by entering your name below.",
        todaysDate: "Today's Date",
      },
      irs: {
        jobApplicant:
          "Job applicant: Fill in the lines below and check any boxes that apply. Complete only this side.",
        name: "Your name",
        ssn: "Social security number",
        street: "Street address where you live",
        cityStateZip: "City or town, state, and ZIP code",
        county: "County Name",
        phone: "Telephone number",
        birthDate: "Date of Birth (if under age 40)",
        items: [
          {
            text:
              "Check here if you received a conditional certification from the state workforce agency (SWA) or a participating local agency for the work opportunity credit.",
          },
          {
            text: "Check here if any of the following statements apply to you.",
            items: [
              {
                text:
                  "I am a member of a family that has received assistance from Temporary Assistance for Needy Families (TANF) for any 9 months during the past 18 months.",
              },
              {
                text:
                  "I am a veteran and a member of a family that received Supplemental Nutrition Assistance Program (SNAP) benefits (food stamps) for at least a 3-month period during the past 15 months.",
              },
              {
                text:
                  "I was referred here by a rehabilitation agency approved by the state, an employment network under the Ticket to Work program, or the Department of Veterans Affairs.",
              },
              {
                text:
                  "I am at least age 18 but not age 40 or older and I am a member of a family that:",
                items: [
                  {
                    text:
                      "Received SNAP benefits (food stamps) for the past 6 months; or",
                  },
                  {
                    text:
                      "Received SNAP benefits (food stamps) for at least 3 of the past 5 months, but is no longer eligible to receive them.",
                  },
                ],
              },
              {
                text:
                  "During the past year, I was convicted of a felony or released from prison for a felony.",
              },
              {
                text:
                  "I received supplemental security income (SSI) benefits for any month ending during the past 60 days.",
              },
              {
                text:
                  "I am a veteran and I was unemployed for a period or periods totaling at least 4 weeks but less than 6 months during the past year.",
              },
            ],
          },
          {
            text:
              "Check here if you are a veteran and you were unemployed for a period or periods totaling at least 6 months during the past year.",
          },
          {
            text:
              "Check here if you are a veteran entitled to compensation for a service-connected disability and you were discharged or released from active duty in the U.S. Armed Forces during the past year.",
          },
          {
            text:
              "Check here if you are a veteran entitled to compensation for a service-connected disability and you were unemployed for a period or periods totaling at least 6 months during the past year.",
          },
          {
            text: "Check here if you are a member of a family that:",
            items: [
              {
                text:
                  "Received TANF payments for at least the past 18 months; or",
              },
              {
                text:
                  "Received TANF payments for any 18 months beginning after August 5, 1997, and the earliest 18-month period beginning after August 5, 1997, ended during the past 2 years; or",
              },
              {
                text:
                  "Stopped being eligible for TANF payments during the past 2 years because federal or state law limited the maximum time those payments could be made.",
              },
            ],
          },
          {
            text:
              "Check here if you are in a period of unemployment that is at least 27 consecutive weeks and for all or part of that period you received unemployment compensation.",
          },
        ],
        allApplicantsMustSign: "Signature — All Applicants Must Sign",
        underPenalties:
          "Under penalties of perjury, I declare that I gave the above information to the employer on or before the day I was offered a job, and it is, to the best of my knowledge, true, correct, and complete.",
        jobApplicantsSignature: "Job applicant's signature",
        forPrivacy:
          "For Privacy Act and Paperwork Reduction Act Notice, see page 2.",
        signatureTitle: "Sign Form 8850",
        signatureStatementLabel: "All applicants must sign and declare",
        signatureStatement:
          "Under penalties of perjury, I declare that I gave the above information to the employer on or before the day I was offered a job, and it is, to the best of my knowledge, true, correct, and complete.",
        signatureLabel: "Sign and declare by entering your name below.",
        todaysDate: "Today's Date",
        privacyActTitle:
          "IRS 8850, Privacy Act and Paperwork Reduction Act Notice",
        privacyActSubtitle:
          "Section references are to the Internal Revenue Code.",
        privacyAct01:
          'Section 51 of the Internal Revenue Code of 1986, as amended, and its enacting legislation (P.L. 104-188), specify that the State Workforce Agencies are the "designated" agencies responsible for administering the WOTC certification process. The information you have provided by completing this Form will be disclosed by your employer to the State Workforce Agency. Provision of this information is voluntary; however, the information is required to determine your employer\'s eligibility for the federal work opportunity tax credit.',
        privacyAct02a:
          "information to other countries under a tax treaty, to federal and state agencies to enforce federal nontax criminal laws, or to federal law enforcement and intelligence agencies to combat terrorism.\n",
        privacyAct02b:
          "You are not required to provide the information requested on a form that is subject to the Paperwork Reduction Act unless the form displays a valid OMB control number. Books or records relating to a form or its instructions must be retained as long as their contents may become material in the administration of any Internal Revenue law. Generally, tax returns and return information are confidential, as required by section 6103.\n",
        privacyAct02c:
          "The time needed to complete and file this form will vary depending on individual circumstances. The estimated average time is:\n",
        privacyAct02d: "• Recordkeeping. . 6 hr., 27 min.\n",
        privacyAct02e: "• Learning about the law or the form......24 min.",
        privacyAct03:
          "• Preparing and sending this form to the SWA......31 min.",
        privacyAct03a:
          "If you have comments concerning the accuracy of these time estimates or suggestions for making this form simpler, we would be happy to hear from you. You can send us comments from www.irs.gov/formspubs. Click on “More Information” and then on “Give us feedback.” Or you can send your comments to:",
        privacyAct03b: "Internal Revenue Service ",
        privacyAct03c: "Tax Forms and Publications ",
        privacyAct03d: "1111 Constitution Ave. NW, IR-6526 ",
        privacyAct03e: "Washington, DC 20224 ",
        privacyAct03f:
          "Do not send this form to this address. Instead, see When and Where To File in the separate instructions.",
        signEnglishForm: "Sign English Form",
        englishRequired:
          "The IRS requires that the 8850 be signed in English. Please click continue to convert the form to English so that you can sign.",
        almostDone: "Thank you! Almost done.",
        filledIn:
          "The next form has been filled in for you based on your previous answers. Please do not make changes unless you made a mistake. Please review it and then sign it at the bottom.",
        continue: "Continue",
      },
      dol: {
        usdol: "U.S. Department of Labor",
        eta: "Employment and Training Administration",
        expirationDate: "Expiration Date",
        title: "Long-Term Unemployment Recipient (LTUR)",
        title2: "Self-Attestation Form (SAF)",
        subtitle: "Work Opportunity Tax Credit",
        instructions:
          "Instructions: The Self-Attestation Form (SAF) is to be completed, signed, and dated by the applicant / new hire, only. Employers or their authorized representatives should submit the completed SAF along with IRS Form 8850, Pre-Screening Notice and Certification Request for the Work Opportunity Tax Credit, or if filed separately, with ETA Form 9061/ETA Form 9062, to the State Workforce Agency (SWA) for each certification request submitted for the Long-Term Unemployment Recipient (LTUR) targeted group.",
        underPenalties:
          "Applicant Self-Attestation: Under penalties of perjury, I declare that the information below is true and correct to the best of my knowledge.",
        signature: "Applicant’s Signature",
        name: "Applicant’s Full Name (Print: First, Middle Initial, Last)",
        ssn: "Applicant’s Social Security Number",
        birthDate: "Date of Birth",
        employerName0: "Employer’s Name",
        employerName: "Employer’s Firm/Company Name",
        employerFID: "Employer Federal ID (EIN) Number",
        check:
          "Applicant Instructions: Please check “√” the statement below if it applies to you and fill in the requested information below.",
        contactFelonyStatement:
          "If needed, do you give WOTC Planet permission to contact you for more information about your Work Release program or conviction & release dates?",
        declaration1:
          "I declare that I was/am in a period of unemployment that was/is at least 27 consecutive weeks; and, for all or part of that unemployment period, I received unemployment\n" +
          "compensation under State or Federal law.",
        declaration2:
          "I have been in a period of unemployment since (Enter unemployment start date: mm/dd/yyyy):",
        multiStateDeclaration:
          "State(s) unemployment compensation was received:",
        privacyActNoticeLabel: "Privacy Act Notice",
        privacyActNotice:
          'Section 51 of the Internal Revenue Code of 1986, as amended, and its enacting legislation (P.L. 104-188), specify that the State Workforce Agencies are the "designated" agencies responsible for administering the WOTC certification process. The information you have provided by completing this Form will be disclosed by your employer to the State Workforce Agency. Provision of this information is voluntary; however, the information is required to determine your employer\'s eligibility for the federal work opportunity tax credit.',
        publicBurdenStatementLabel: "Public Burden Statement",
        publicBurdenStatement:
          "Persons are not required to respond to this collection of information unless it displays a currently valid OMB control number. Respondents' obligation to complete this Form is required to obtain or retain benefits (P.L. 111-5). Public reporting burden is estimated to average 10 minutes per response, including the time for reviewing instructions, searching existing data sources, gathering and maintaining the data needed, and completing and reviewing the collection of Information. Send comments regarding this burden estimate to the U.S. Department of Labor, Division of National Programs Tools Technical Assistance, Room C-4510, Washington, D.C. 20210 (Paperwork Reduction Act – OMB Control No. 1205-0371). Please do not submit completed WOTC processing forms to this address.",
        signatureTitle: "Sign SAF Form",
        signatureStatementLabel: "Applicant Self-Attestation",
        signatureStatement:
          "Under penalties of perjury, I declare that the information below is true and correct to the best of my knowledge.",
        signatureLabel: "Sign and declare by entering your name below.",
        todaysDate: "Today's Date",
        signEnglishForm: "Sign English Form",
        englishRequired:
          "The DOL requires that the 9175 be signed in English. Please click continue to convert the form to English so that you can sign.",
        almostDone: "Just one more form!",
        filledIn:
          "The next form has also been filled in for you based on your previous answers. Please do not make changes unless you made a mistake. Please review it and then sign it at the bottom.",
        continue: "Continue",
      },
      submitted: {
        thankYou:
          "Thank you for your help.  If needed, we will follow up with you by email or telephone.",
        confirmation: "Your Confirmation ID# is",
        disclaimer:
          "If your employer asked for it, please copy and provide the ",
        confirmationID: "Confirmation ID#",
      },
    },
    spanish: {
      shared: {
        language_name: "Español",
        subtitle:
          "Respuestas honestas son los mejores!  Conteste por favor cada pregunta.",
        yes: "Sí",
        no: "No",
        date_selection: "Por favor, elija Mes, después Año y Día",
        true: "Verdadero ",
        false: "Falso",
        back: "Atrás",
        previous: "Atrás",
        next: "Adelante",
        required: "Requerido",
        invalid_ss_number: "Número de seguro social inválido",
        invalid_tel_number: "Número de teléfono inválido",
        invalid_email: "Email inválido",
        invalid_state: "Estado inválido",
        invalid_zip_: "Código postal inválido",
        change_language: "Cambiar Idioma",
        first_name: "Nombre",
        last_name: "Apellido",
        month: "Mes",
        day: "Día",
        year: "Año",
        months: {
          jan: "enero",
          feb: "feb",
          mar: "marzo",
          apr: "abr",
          may: "mayo",
          jun: "jun",
          jul: "jul",
          aug: "agosto",
          sep: "sept",
          oct: "oct",
          nov: "nov",
          dec: "dic",
        },
        state: "Estado",
        federal: "Federal",
        states: [
          "AL",
          "AK",
          "AZ",
          "AR",
          "CA",
          "CO",
          "CT",
          "DE",
          "FL",
          "GA",
          "HI",
          "ID",
          "IL",
          "IN",
          "IA",
          "KS",
          "KY",
          "LA",
          "ME",
          "MD",
          "MA",
          "MI",
          "MN",
          "MS",
          "MO",
          "MT",
          "NE",
          "NV",
          "NH",
          "NJ",
          "NM",
          "NY",
          "NC",
          "ND",
          "OH",
          "OK",
          "OR",
          "PA",
          "RI",
          "SC",
          "SD",
          "TN",
          "TX",
          "UT",
          "VT",
          "VA",
          "WA",
          "WV",
          "WI",
          "WY",
          "AS",
          "DC",
          "FM",
          "GU",
          "MH",
          "MP",
          "PW",
          "PR",
          "VI",
          "AE",
          "AA",
          "AP",
        ],
        finish: "Finalizar",
        edit: "Cambiar",
        sign: "Firmar",
        of: "de",
        answered: "contestada",
        signed: "firmado",
        startOver: "comenzar de nuevo",
        date: "fecha",
        email: "Dirección de correo electrónico",
        continue: "Continuar",
        required_message:
          "Todas las preguntas deben ser completadas, Por favor completa todos los campos antes de continuar.",
      },
      intro: {
        title:
          "Por favor, complete este importante cuestionario sobre créditos fiscales.",
        title2: "¿Está listo para completar el cuestionario WOTC?",
        paragraph01:
          "WOTC Planet solicita información para ayudar a este empleador a participar en el programa de Crédito Fiscal por Oportunidad de Trabajo (WOTC, por sus siglas en inglés); el empleador no recibe sus respuestas. El programa WOTC puede ayudar a los miembros de sus grupos especificados a conseguir empleo mediante la reducción del impuesto federal sobre la renta de los empleadores.",
        paragraph02:
          "Responder las preguntas de elegibilidad para el WOTC es voluntario. Recibirá el mismo trato independientemente de si responde a dichas preguntas o no. La información que proporcione se mantendrá confidencial y podrá divulgarse a la agencia estatal de empleo para confirmar la elegibilidad. Se utilizará únicamente para este fin y de conformidad con la ADA y otras leyes contra la discriminación.",
        information02: "optar por no",
        rightBottomInformation01: "¡Necesitamos su ayuda!",
        rightBottomInformation02: "¡No podemos hacerlo sin usted!",
        rightBottomInformation03: "Haga clic en CONTINUAR ahora.",
      },
      info01: {
        title: "Información del empleado",
        subtitle: "",
        name: "Nombre",
        ssn: "Número de seguridad social",
        ageRange: "¿Tiene menos de 40 años de edad?",
        birthDate: "Fecha de Nacimiento",
        birthDatePrompt:
          "Si tiene menos de 40 años, ingrese su fecha de nacimiento.",
        email: "Dirección de correo electrónico",
        phone: "Número de teléfono",
        job_description: "Título o descripcion de trabajo",
        starting_pay: "Salario inicial (si se conoce)",
        starting_pay_holder: "Si no está seguro, una estimación está bien.",
      },
      intro01: {
        middleParagraph0101: "Solo para confirmar, ",
        middleParagraph0102:
          ", ¿ha decidido omitir las preguntas de elegibilidad para el WOTC?",
        middleParagraph0103:
          "Sus respuestas son confidenciales y no afectarán negativamente su oportunidad de empleo. Solo le tomará unos minutos y contribuirá a un programa que ayuda a los empleadores a invertir en oportunidades laborales en comunidades como la suya.",
        middleParagraph02: "Si desea finalizar ahora, haga clic en ",
        endNow: "Finalizar ahora",
        middleParagraph03:
          "Si ha cambiado de opinión y desea continuar, haga clic en Continuar a continuación.",
        bottomParagraph01:
          "Su empleador puede perder un beneficio fiscal sin eso.",
        bottomParagraph02:
          "¡Para completar sus formularios WOTC, haz clic CONTINUAR!",
      },
      info02: {
        title: "Información del empleado",
        subtitle: "(continuado)",
        street: "Dirección de la calle donde vive",
        city: "Ciudad",
        county: "Nombre del Condado",
        state: "Estado",
        zip: "Código postal",
        hireDate: "Fecha de empleo (si se conoce)",
        workedForUsBefore: "¿Ha trabajado usted para nosotros antes?",
        dobCheck: "Por favor, verifique su fecha de nacimiento",
      },
      section01: {
        title: "01",
        primaryQuestion:
          "¿Es usted un veterano del ejército de los\nEstados Unidos?",
        question01:
          "¿Tiene usted derechos a recibir compensación\npor incapacidad física como resultado de su\nservicio militar?",
        question02: "¿Cuál fue la fecha en que usted fue dado de baja?",
        question03: "¿Cual división?",
        question03Placeholder: "División",
      },
      section02: {
        title: "02",
        primaryQuestion:
          "¿Fue usted desempleado durante cualquier\n4 semanas durante el último año?",
      },
      section03: {
        title: "03",
        primaryQuestion:
          "¿Fue usted desempleado durante cualquier\ncombinación de días sumando a un total de\n6 meses durante el último año?",
      },
      section04: {
        title: "04",
        primaryQuestion:
          "¿Fue referido usted aquí por cualquiera\nde los siguientes organismos? Por favor\nmarque Sí o No.",
        question01: "¿Una Agencia de Rehabilitación Vocacional",
        question02: "¿El programa Ticket to Work Work?",
        question03: "¿El Departamento de Asuntos de los Veteranos?",
      },
      section05: {
        title: "05",
        primaryQuestion:
          "¿Recibio usted mismo beneficios de\nIngresos Suplementarios de Seguridad”\n(SSI) durante cualquier mes en los\nultimos 3 meses?",
      },
      section06: {
        title: "06",
        primaryQuestion: "¿Ha sido usted convicto de un delito?",
        question01: "Fecha de condena:",
        question02: "Fecha de liberación:",
      },
      section06b: {
        title: "6b",
        primaryQuestion: "Por favor responda lo siguiente:",
        question04: "¿Era una condena de estado o una condena\nfederal?",
        question05: "Ciudad o condado donde recibió la condena:",
        question05Placeholder: "Ciudad o condado",
        question06: "Estado:",
      },
      section06c: {
        title: "6c",
        primaryQuestion: "Por favor responda lo siguiente:",
        question07: "Nombre de su oficial de libertad condicional:",
        question07Placeholder: "Nombre del oficial",
        question08: "Número de teléfono de su oficial de libertad condicional:",
        question08Placeholder: "Número de teléfono del oficial",
        question09: "¿Está usted en un Programa de Reclusorio Laboral?",
        question10:
          "¿Le da permiso a WOTC Planet\npara comunicarse con usted para obtener\nmás información sobre su Programa de Reclusorio\nLaboral o las fechas de su condena y liberación? Al marcar SÍ a continuación, doy mi permiso.\n",
      },
      section07: {
        title: "07",
        primaryQuestion:
          "¿Recibio usted o su familia beneficios del\nPrograma Suplementario de Alimentacion\nNuntricional (SNAP) o  Cupones de Alimentos\ndurante cualquier periodo en los ultimos\n6 meses?",
      },
      section08: {
        title: "08",
        primaryQuestion:
          "¿Recibio usted o su familia TANF – Ayuda\nProvisional a Familias Necesitadas u otro\nsubsidio de bienestar durante cualquier\nperiodo en los ultimos 3 anos?",
      },
      section09: {
        title: "09",
        primaryQuestion:
          "¿Recibio usted o su familia beneficios del\nPrograma Suplementario de Alimentacion\nNuntricional (SNAP) o  Cupones de Alimentos\ndurante cualquier periodo en el año y medio\npasado?",
      },
      section09b: {
        title: "9b",
        primaryQuestion:
          "Porque alguien en su hogar ha recibido SNAP, Cupones de Alimentos, el bienestar, o de TANF, por favor proporcione la siguiente:",
        summaryQuestion:
          "If your answer to any of the questions inside this box is yes, please provide the following:",
        question01:
          "Nombre de la persona que se inscribieron\npara recibir beneficios de SNAP, Cupones\nde Alimentos, el bienestar, o de TANF:",
        question01Placeholder: "Nombre",
        question02: "Ciudad y estado donde se recibieron beneficios:",
        question02Placeholder: "Ciudad y estado",
      },
      section10: {
        title: "10",
        primaryQuestion:
          "Por favor indicar si las siguientes afirmaciones son verdaderas o falsas:",
        question01:
          "Hasta que fui contratado aquí,\nyo estaba sin trabajo durante\n27 semanas consecutivas (un poco\nmás de 6 meses) o más largo.",
        question02:
          "Durante este período de desempleo,\ntambién recibí compensación por\ndesempleo al menos una vez.",
        unemploymentStart: "Mi período de desempleo se inició en:",
        unemployment_state:
          "Estado(s) donde recibió compensación por desempleo:",
      },
      summary: {
        title:
          "A continuación se muestra un resumen de sus respuestas. Después de revisar sus respuestas, haga clic en el botón FIRMAR ubicado en la parte inferior. Si necesita volver y modificar sus respuestas, haga clic en el botón CAMBIAR.",
        employeeInformation: "Información del empleado",
        signatureTitle: "Firmar el formulario",
        signatureStatementLabel: "Declaración",
        signatureStatement:
          "Declaro bajo pena de perjurio que mis respuestas son verdaderas a mi leal saber y entender. Entiendo que WOTC Planet procesa esta información en nombre de mi empleador y mi empleador no recibe mis respuestas.\n" +
          "\n" +
          "Para verificar la elegibilidad: autorizo a WOTC Planet a verificar mis fechas de servicio militar y otra información proporcionada y a contactarme si es necesario. WOTC Planet puede transferir mi información a los formularios requeridos por la agencia laboral estatal. Se pueden utilizar como originales los formularios y firmas electrónicos y enviados por fax. Estas autorizaciones vencen en 24 meses pero puedo cancelarlas antes comunicándome con WOTC Planet.",
        signatureLabel: "Firme y declare introduciendo su nombre abajo.",
        todaysDate: "El día de hoy",
      },
      irs: {
        jobApplicant:
          "Solicitante de Trabajo: Llene los siguientes blancos y marque con una (X) los encasillados que apliquen. Llene sólo esta página.",
        name: "Su Nombre",
        ssn: " Número de Seguro Social",
        street: "Dirección de la Calle Donde Usted Vive",
        cityStateZip: "Pueblo/Ciudad y Código Posta",
        county: "Nombre del Condado",
        phone: "Número de su Teléfono",
        birthDate: "Fecha de Nacimiento (si tiene menos de 40 años)",
        items: [
          {
            text:
              "Marque aquí con una X si Usted recibió una Certificación Condicional de la agencia de empleo estatal o de una agencia local como elegible para participar en el Programa WOTC.",
          },
          {
            text:
              "Marque aquí con una X si una de las siguientes situaciones le aplican a Usted",
            items: [
              {
                text:
                  "Soy miembro de una familia que ha recibido “Ayuda Provisional a Familias Necesitadas” (TANF) o beneficios de un programa sucesor durante cualquier periodo de 9 meses en los últimos 18 meses.",
              },
              {
                text:
                  "Soy veterano y miembro de una familia que recibió beneficios del Programa Suplementario de Alimentación Nutricional (SNAP) (Cupones de Alimentos o Programa de “Pan y Trabajo” en Puerto Rico) por lo menos durante un periodo de 3-meses dentro de los últimos 15 meses.",
              },
              {
                text:
                  "Fui referido aquí por una Agencia de Rehabilitación Vocacional, la Administración de Asuntos de Veteranos o por una agencia conocida como “Employment Network” del programa Ticket to Work.",
              },
              {
                text:
                  "Tengo por lo menos 18 años pero soy menor de 40 años y soy miembro de una familia que:",
                items: [
                  {
                    text:
                      "Recibí beneficios del Programa SNAP conocido como (Cupones de Alimentos) durante los últimos 6 meses, o",
                  },
                  {
                    text:
                      "Recibí beneficios de SNAP conocido como (Cupones de Alimentos) por lo menos durante 3 de los últimos 5 meses, PERO ya mi familia NO es elegible para recibir estos beneficios.",
                  },
                ],
              },
              {
                text:
                  "Durante el año pasado, fui convicto por cometer una felonía/delito o salí libre de la cárcel.",
              },
              {
                text:
                  "Recibí beneficios de “Ingreso por Seguro Suplementario” (SSI) durante cualquier mes en los últimos 60 días.",
              },
              {
                text:
                  "Soy veterano y estuve desempleado por un periodo de por lo menos 4 semanas pero menos de 6 meses durante el año pasado.",
              },
            ],
          },
          {
            text:
              "Marque aquí con una X si Usted es un veterano y estuvo desempleado por un periodo o periodos de 6 meses durante el pasado año.",
          },
          {
            text:
              "Marque aquí con una X si Usted es un veterano con derechos a recibir compensación por Incapacidad Física como resultado de su Servicio Activo Militar en las Fuerzas Armadas de los EUA, y fue dado de baja del Servicio Activo Militar en las Fuerzas Armadas de los EUA en el pasado año.",
          },
          {
            text:
              "Marque aquí con una X si Usted es un veterano con derechos a recibir compensación por Incapacidad Física como resultado de su Servicio Activo Militar en las Fuerzas Armadas de los EUA, y estuvo desempleado por un periodo o periodos de ses meses durante el pasado año.",
          },
          {
            text:
              "Marque aquí con una X si Usted es un miembro de una familia que:",
            items: [
              {
                text:
                  " Recibió beneficios de “Ayuda Provisional a Familias Necesitadas” (TANF) por los menos durante los últimos 18 meses consecutivos, o",
              },
              {
                text:
                  "Recibió beneficios de TANF durante cualquier periodo de 18 meses comenzando después del 5 de agosto de 1997, y el periodo mas reciente de 18 meses de beneficios recibidos después del 5 de agosto del 1997 termino en los últimos 2 años; o",
              },
              {
                text:
                  " Dejó de ser elegible para recibir beneficios de “Ayuda Provisional a Familias Necesitadas” (TANF) en los últimos 2 años porque una ley Federal o estatal redujo el periodo máximo para Ud. recibir dichos beneficios.",
              },
            ],
          },
          {
            text:
              "Marque aqui con una X si Usted se encuentra en un periodo de desempleo que es por lo menos 27 semana consecutivas y para la totalidad or parte de ese periodo que ha recibido compensacion por desempleo.",
          },
        ],
        allApplicantsMustSign: "Todos los Solicitantes Tienen Que Firmar",
        underPenalties:
          "Bajo penalidad de perjurio, declaro que ofrecí esta información al patrono en o antes del día en que se me ofreció empleo, y es verdadera, correcta y completa",
        jobApplicantsSignature: "La firma del solicitante",
        forPrivacy:
          "For Privacy Act and Paperwork Reduction Act Notice, see page 2.",
        signatureTitle: "Firmar el Formulario 8850",
        signatureStatementLabel: "Todos los Solicitantes Tienen Que Firmar",
        signatureStatement:
          "Bajo penalidad de perjurio, declaro que ofrecí esta información al patrono en o antes del día en que se me ofreció empleo, y es verdadera, correcta y completa.",
        signatureLabel: "Firme y declare introduciendo su nombre abajo.",
        todaysDate: "El día de hoy",
        privacyActTitle:
          "IRS 8850, Privacy Act and Paperwork Reduction Act Notice",
        privacyActSubtitle:
          "Section references are to the Internal Revenue Code.",
        privacyAct01:
          "Section 51(d)(13) permits a prospective employer to request the applicant to complete this form and give it to the prospective employer. The information will be used by the employer to complete the employer’s federal tax return. Completion of this form is voluntary and may assist members of targeted groups in securing employment. Routine uses of this form include giving it to the state workforce agency (SWA), which will contact appropriate sources to confirm that the applicant is a member of a targeted group. This form may also be given to the Internal Revenue Service for administration of the Internal Revenue laws, to the Department of Justice for civil and criminal litigation, to the Department of Labor for oversight of the certifications performed by the SWA, and to cities, states, and the District of Columbia for use in administering their tax laws. We may also disclose this",
        privacyAct02a:
          "information to other countries under a tax treaty, to federal and state agencies to enforce federal nontax criminal laws, or to federal law enforcement and intelligence agencies to combat terrorism.\n",
        privacyAct02b:
          "You are not required to provide the information requested on a form that is subject to the Paperwork Reduction Act unless the form displays a valid OMB control number. Books or records relating to a form or its instructions must be retained as long as their contents may become material in the administration of any Internal Revenue law. Generally, tax returns and return information are confidential, as required by section 6103.\n",
        privacyAct02c:
          "The time needed to complete and file this form will vary depending on individual circumstances. The estimated average time is:\n",
        privacyAct02d: "• Recordkeeping. . 6 hr., 27 min.\n",
        privacyAct02e: "• Learning about the law or the form......24 min.",
        privacyAct03:
          "• Preparing and sending this form to the SWA......31 min.",
        privacyAct03a:
          "If you have comments concerning the accuracy of these time estimates or suggestions for making this form simpler, we would be happy to hear from you. You can send us comments from www.irs.gov/formspubs. Click on “More Information” and then on “Give us feedback.” Or you can send your comments to:",
        privacyAct03b: "Internal Revenue Service ",
        privacyAct03c: "Tax Forms and Publications ",
        privacyAct03d: "1111 Constitution Ave. NW, IR-6526 ",
        privacyAct03e: "Washington, DC 20224 ",
        privacyAct03f:
          "Do not send this form to this address. Instead, see When and Where To File in the separate instructions.",
        signEnglishForm: "Continuar",
        englishRequired:
          "El IRS requiere que el Formulario 8850 sea firmado en inglés. Haga clic en continuar para convertir el formulario en inglés para que pueda firmar.",
        almostDone: "Gracias. Casi termino.",
        filledIn:
          "El siguiente formulario se ha rellenado para usted basado en sus respuestas anteriores. No realice cambios a menos que haya cometido un error. Por favor, revise y luego firme en la parte inferior.",
        continue: "Continuar",
      },
      dol: {
        usdol: "Departamento de Trabajo de los Estados Unidos",
        eta: "Administración de Empleo y Capacitación",
        expirationDate: "Fecha de caducidad",
        title: "Long-Term Unemployment Recipient (LTUR)",
        title2: "Self-Attestation Form (SAF)",
        subtitle: "Work Opportunity Tax Credit",
        instructions:
          "Instrucciones: El formulario de autodeclaración (SAF) debe ser completado, firmado y fechado únicamente por el solicitante/nuevo empleado. Los empleadores o sus representantes autorizados deben presentar el SAF completo junto con el formulario 8850 del IRS, Aviso de evaluación previa y solicitud de certificación para el crédito fiscal por oportunidad laboral, o si se presenta por separado, con el formulario ETA 9061/formulario ETA 9062, a la Agencia Estatal de Fuerza Laboral ( SWA) para cada solicitud de certificación presentada para el grupo objetivo de beneficiarios de desempleo a largo plazo (LTUR).",
        underPenalties:
          "Autocertificación del solicitante: Bajo pena de perjurio, declaro que la siguiente información es verdadera y correcta a mi leal saber y entender.",
        signature: "Firma del Empleado Nuevo",
        name: "Nombre del Empleado Nuevo",
        ssn: "Número de seguridad socia",
        birthDate: "Fecha de nacimiento",
        employerName0: "Nombre del empleador",
        employerName: "Nombre de la empresa",
        employerFID: "Número de Identificación Federal del Patrono",
        check:
          "Instrucciones para el solicitante: Marque “√” la siguiente declaración si se aplica a usted y complete la información solicitada a continuación.",
        contactFelonyStatement:
          "De ser necesario, ¿le da permiso a WOTC Planet para comunicarse con usted para obtener más información sobre su Programa de Reclusorio Laboral o las fechas de su condena y liberación?",
        declaration1:
          "Declaro que estuve/estoy en un período de desempleo de al menos 27 semanas consecutivas; y, durante todo o parte de ese período de desempleo, recibí compensación por desempleo según la ley estatal o federal.",
        declaration2:
          "Estoy en un periodo de desempleo desde (Ingrese la fecha de inicio del desempleo)",
        multiStateDeclaration:
          "Estado(s) donde recibió compensación por desempleo:",
        privacyActNoticeLabel: "Aviso sobre la Ley de Privacidad",
        privacyActNotice:
          'La Sección 51 del Código de Rentas Internas de 1986, según enmendado, y su legislación promulgante (P.L. 104-188), especifican que las Agencias Estatales de Fuerza Laboral son las agencias "designadas" responsables de administrar el proceso de certificación WOTC. La información que usted ha proporcionado al completar este formulario será divulgada por su empleador a la Agencia Estatal de Fuerza Laboral. La provisión de esta información es voluntaria; sin embargo, la información es necesaria para determinar la elegibilidad de su empleador para el crédito fiscal federal por oportunidad de trabajo.',
        publicBurdenStatementLabel: "Declaración de carga pública",
        publicBurdenStatement:
          "Las personas no están obligadas a responder a esta recopilación de información a menos que muestre un número de control de la OMB actualmente válido. La obligación de los encuestados de completar este formulario es necesaria para obtener o retener beneficios (P.L. 111-5). Se estima que la carga de presentación de informes públicos es de un promedio de 10 minutos por respuesta, incluido el tiempo para revisar las instrucciones, buscar fuentes de datos existentes, recopilar y mantener los datos necesarios y completar y revisar la recopilación de información. Envíe comentarios sobre esta estimación de carga al Departamento de Trabajo de EE. UU., División de Asistencia Técnica de Herramientas de Programas Nacionales, Sala C-4510, Washington, D.C. 20210 (Ley de Reducción de Trámites – Control de la OMB No. 1205-0371). No envíe formularios de procesamiento WOTC completos a esta dirección.",
        signatureTitle: "Firmar el Formulario SAF",
        signatureStatementLabel: "Autocertificación del solicitante",
        signatureStatement:
          "Bajo pena de perjurio, declaro que la siguiente información es verdadera y correcta a mi leal saber y entender.",
        signatureLabel: "Firme y declare introduciendo su nombre abajo.",
        todaysDate: "El día de hoy",
        signEnglishForm: "Continuar",
        englishRequired:
          "El Departamento de Trabajo exige que este formulario sea firmado en inglés. Haga clic en continuar para convertir el formulario en inglés para que pueda firmar.",
        almostDone: "Hay solo un formulario más.",
        filledIn:
          "El siguiente formulario también se ha rellenado para usted basado en sus respuestas anteriores. No realice cambios a menos que haya cometido un error. Por favor, revise y luego firme en la parte inferior.",
        continue: "Continuar",
      },
      submitted: {
        thankYou:
          "Gracias por su ayuda. Si es necesario, nos pondremos en contacto con usted por correo electrónico o por teléfono.",
        confirmation: "Su número de identificación de confirmación es",
        disclaimer: "Si su empleador lo solicita, copie y proporcione este ",
        confirmationID: "número de confirmación",
      },
    },
  },
};



// WEBPACK FOOTER //
// ./src/constants/defaultValues.js